import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React from 'react'
import { Else, If, Then } from 'react-if'

import FAIcon from '../../Theme/FAIcon'
import { FA_ICONS, FA_KIT_ICONS } from '../../Theme/font-awesome-icon-constants'
import { List, ListItem, ListItemIcon, ListItemText } from '../../Theme/List'
import { getFullDate } from '../../utils/date-utils'
import GameTypeIcon from '../_common/GameTypeIcon'

// TODO need skeleton and isLoading prop
const ContestRulesInfo = ({
  gameTitle = '',
  categoryName = '',
  mapPlayers = '',
  submissionDeadline = '',
  contestTag = '',
  mapsPerAuthor = 1,
  isCoforges = false,
  isRemakesAllowed = false,
  isSubmitMapDialog = false,
  isMobile = false,
  width = 500,
}) => (
  <If condition={isSubmitMapDialog}>
    <Then>
      <List
        inset="true"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          width: width,
          justifyContent: 'center',
          '& .MuiListItem-root': {
            width: 'auto',
          },
          '& .MuiListItemIcon-root': {
            marginRight: '8px',
          },
          '& svg': {
            fontSize: 14,
          },
        }}
      >
        <ListItem>
          <ListItemIcon>
            <FAIcon iconClassName={FA_ICONS.GAMEPAD} />
          </ListItemIcon>
          <ListItemText primary={gameTitle} />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <GameTypeIcon
              size={16}
              gameType={categoryName}
            />
          </ListItemIcon>

          <ListItemText primary={categoryName} />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <FAIcon iconClassName={FA_ICONS.USER_GROUP} />
          </ListItemIcon>
          <ListItemText primary={mapPlayers} />
        </ListItem>

        {!isRemakesAllowed && (
          <ListItem>
            <ListItemIcon>
              <FAIcon iconClassName={FA_ICONS.BAN} />
            </ListItemIcon>
            <ListItemText primary="No Remakes" />
          </ListItem>
        )}

        {isCoforges && (
          <ListItem>
            <ListItemIcon>
              <FAIcon iconClassName={FA_ICONS.USER_PLUS} />
            </ListItemIcon>
            <ListItemText primary="Co-Forgers allowed" />
          </ListItem>
        )}

        {contestTag && (
          <ListItem>
            <ListItemIcon>
              <FAIcon iconClassName={FA_ICONS.TAG} />
            </ListItemIcon>
            <ListItemText primary={`add the unique tag '${contestTag}'`} />
          </ListItem>
        )}
      </List>
    </Then>

    <Else>
      <Box>
        <Box
          sx={{
            paddingBottom: '16px',
          }}
        >
          <Typography
            variant="h6"
            color="text.secondary"
          >
            Rules
          </Typography>
        </Box>

        <List
          component={Paper}
          inset="true"
          sx={{
            '& .MuiListItemIcon-root': {
              display: 'flex',
              alignItems: 'center',
              marginRight: '8px',
            },
          }}
        >
          {gameTitle && (
            <ListItem>
              <ListItemIcon>
                <FAIcon
                  iconClassName={FA_ICONS.GAMEPAD}
                  iconFontSize={14}
                />
              </ListItemIcon>
              <ListItemText
                primary={gameTitle}
                secondary={!isMobile && 'Game'}
              />
            </ListItem>
          )}

          {categoryName && (
            <ListItem>
              <ListItemIcon>
                <GameTypeIcon
                  size="small"
                  gameType={categoryName}
                />
              </ListItemIcon>
              <ListItemText
                primary={categoryName}
                secondary={!isMobile && 'Category'}
              />
            </ListItem>
          )}

          {mapPlayers && (
            <ListItem>
              <ListItemIcon>
                <FAIcon
                  iconClassName={FA_ICONS.USER_GROUP}
                  iconFontSize={14}
                />
              </ListItemIcon>
              <ListItemText
                primary={mapPlayers}
                secondary={!isMobile && 'Players'}
              />
            </ListItem>
          )}

          {submissionDeadline && (
            <ListItem>
              <ListItemIcon>
                <FAIcon
                  iconClassName={FA_ICONS.CALENDAR}
                  iconFontSize={14}
                />
              </ListItemIcon>
              <ListItemText
                primary={getFullDate(submissionDeadline)}
                secondary={!isMobile && 'Due Date'}
              />
            </ListItem>
          )}
          {mapsPerAuthor && (
            <ListItem>
              <ListItemIcon>
                <FAIcon
                  iconClassName={FA_KIT_ICONS.SUBMIT_MAP_PLUS}
                  iconFontSize={16}
                />
              </ListItemIcon>
              <ListItemText primary={`${mapsPerAuthor} submissions allowed`} />
            </ListItem>
          )}
          {isCoforges && (
            <ListItem>
              <ListItemIcon>
                <FAIcon
                  iconClassName={FA_ICONS.USER_PLUS}
                  iconFontSize={14}
                />
              </ListItemIcon>
              <ListItemText primary="Co-Forgers allowed" />
            </ListItem>
          )}

          <ListItem>
            <ListItemIcon>
              <FAIcon
                iconClassName={FA_KIT_ICONS.JUGGERNAUT}
                iconFontSize={16}
              />
            </ListItemIcon>
            <ListItemText primary={isRemakesAllowed ? 'Remakes allowed' : 'Remakes not allowed'} />
          </ListItem>
        </List>
      </Box>
    </Else>
  </If>
)

ContestRulesInfo.propTypes = {
  gameTitle: PropTypes.string,
  categoryName: PropTypes.string,
  mapPlayers: PropTypes.string,
  isMultipleSubmissions: PropTypes.bool,
  isCoforges: PropTypes.bool,
  isRemakesAllowed: PropTypes.bool,
  isSubmitMapDialog: PropTypes.bool,
}

export default ContestRulesInfo
